import type { CampaignRepository } from '@zetyar/data-contracts'
import { createSupabaseCampaignRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webCampaignRepository: CampaignRepository = createSupabaseCampaignRepository(getSupabaseClient())
